import { colors } from '../../Pages/Sindico/colors';
import styled from 'styled-components';

export const StyledBreadcrumb = styled.div`
  display: flex;
  justify-content: space-between;
  .back-title {
    display: flex;
    gap: 16px;
    align-items: center;

    box-sizing: border-box;

    width: 100%;

    svg {
      display: block;
      &:hover {
        opacity: 0.8;
        cursor: pointer;
      }
    }
  }

  .paths {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const BreadcrumbItem = styled.span`
  color: ${colors.gray[700]};
  font-size: 16px;

  font-weight: ${({ $isCurrentPath }) => ($isCurrentPath ? '500' : 'normal')};

  &:hover {
    color: ${({ $isCurrentPath }) =>
      !$isCurrentPath ? colors.primary : colors.gray[700]};
    cursor: ${({ $isCurrentPath }) => (!$isCurrentPath ? 'pointer' : 'text')};
  }

  @media (max-width: 768px) {
    span {
      vertical-align: bottom;
    }

    &:not(:last-child) .path-name {
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 55px;
    }

    &:last-child .path-name {
      width: auto !important;
    }
  }
`;
